import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter, Route } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';

/**
 * Components
 */
import PublicHome from './components/publicHome/PublicHome';
import Champ from './components/champ/Champ';
import Event from './components/event/Event';
import Home from './components/home/Home';
import Champs from './components/champs/Champs';
import ChampManagement from './components/champManagement/Champ';
import Events from './components/events/Events';
import Weighing from './components/weighing/Weighing';
import SearchCompetitor from './components/searchCompetitor/SearchCompetitor';
import SwitchingContainer from './components/switchingContainer/SwitchingContainer';
import RotationContainer from './components/rotationContainer/RotationContainer';
import ConfrontationSwitchingAndRotation from './components/confrontationSwitchingAndRotation/ConfrontationSwitchingAndRotation';
import ConfrontationSwitching from './components/confrontationSwitching/ConfrontationSwitching';
import Scoreboard from './components/scoreboard/Scoreboard';
import ConfrontationRotation from './components/confrontationRotation/ConfrontationRotation';
// import PublicChamps from './components/publicChamps/PublicChamps'
// import PublicEvents from './components/publicEvents/PublicEvents'
// import PublicPhotos from './components/publicPhotos/PublicPhotos'
// //import Menu from './components/menu/Menu'
// import Registration from './components/registration/Registration'
// import Switching from './components/switching/Switching'
// import Confrontation from './components/confrontation/Confrontation'
// import Rotation from './components/rotation/Rotation'

/**
 * Firebase configs
 */
let config = {
	apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
	authDomain: "furia-fight.firebaseapp.com",
	databaseURL: "https://furia-fight.firebaseio.com",
	projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
	storageBucket: "furia-fight.appspot.com",
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID
};
const firebaseApp = initializeApp(config);

// Get a reference to the storage service, which is used to create references in your storage bucket
getStorage(firebaseApp);

ReactDOM.render(
	(
		<MuiThemeProvider>
			<BrowserRouter>
				<Fragment>
					<Route exact path="/" component={PublicHome} />

					<Route exact path="/champ" component={Champ} />
					<Route exact path="/event" component={Event} />

					<Route exact path="/home" component={Home} />

					<Route exact path="/home/champs" component={Champs} />
					<Route exact path="/home/champs/:key" component={ChampManagement} />
					<Route exact path="/home/champs/:key/weighing" component={Weighing} />
					<Route exact path="/home/champs/:key/search-competitor" component={SearchCompetitor} />
					<Route exact path="/home/champs/:key/switching" component={SwitchingContainer} />
					<Route exact path="/home/champs/:key/rotation" component={RotationContainer} />

					<Route exact path="/home/champs/:key/confrontation" component={ConfrontationSwitchingAndRotation} />
					<Route exact path="/home/champs/:key/confrontation/switching" component={ConfrontationSwitching} />
					<Route exact path="/home/champs/:key/confrontation/switching/scoreboard" component={Scoreboard} />

					<Route exact path="/home/champs/:key/confrontation/rotation" component={ConfrontationRotation} />
					<Route exact path="/home/champs/:key/confrontation/rotation/scoreboard" component={Scoreboard} />

					<Route exact path="/home/events" component={Events} />

					{/* <Route path="/index" component={PublicTopBar} />
					<Switch>
						<Route exact path="/index" component={PublicHome} />
						<Route exact path="/index/publicChamps" component={PublicChamps} />
						<Route exact path="/index/publicEvents" component={PublicEvents} />
						<Route exact path="/index/publicPhotos" component={PublicPhotos} />

						<Fragment>
							<Route path="/home" component={TopBar} />
							<Switch>
								<Route exact path="/home" component={Home} />
								<Route exact path="/home/events" component={Events} />
								<Route exact path="/home/champs" component={Champs} />
								<Route exact path="/home/champs/:key" component={Champ} />
								<Route exact path="/home/champs/:key/weighing" component={Weighing} />
								<Route exact path="/home/champs/:key/rotation" component={RotationContainer} />
								<Route exact path="/home/champs/:key/confrontation" component={ConfrontationSwitchingAndRotation} />
								<Route exact path="/home/champs/:key/confrontation/switching" component={ConfrontationSwitching} />
								<Route exact path="/home/champs/:key/confrontation/switching/scoreboard" component={Scoreboard} />
								<Route exact path="/home/champs/:key/confrontation/rotation" component={ConfrontationRotation} />
								<Route exact path="/home/champs/:key/confrontation/rotation/scoreboard" component={Scoreboard} />

								<Route exact path="/home/champs/:key/registration" component={Registration} />

								<Route exact path="/home/champs/:key/confrontation/:confrontationId" component={Confrontation} />
								<Route exact path="/home/champs/:key/scoreboard" component={Scoreboard} />

								<Fragment>
									<Switch>
										<Route exact path="/home/champs/:key/rotation/:rotationId" component={Rotation} />
										<Route exact path="/home/champs/:key/switching/:switchingId" component={Switching} />
									</Switch>
								</Fragment>
							</Switch>
						</Fragment>
					</Switch> */}
				</Fragment>
			</BrowserRouter>
		</MuiThemeProvider>
	), document.getElementById('root')
)

registerServiceWorker()
